import { REQ_ID_HISTORY_DATA, REQ_ID_HISTORY_ERROR, REQ_ID_HISTORY_HIDE_ERROR, REQ_ID_HISTORY_START_LOADER, REQ_ID_HISTORY_STOP_LOADER, } from "../interface/ReqIdHistory";
const initialState = {
    data: [],
    reqIdHistoryLoader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const reqIdHistory = (state = initialState, action) => {
    switch (action.type) {
        case REQ_ID_HISTORY_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case REQ_ID_HISTORY_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case REQ_ID_HISTORY_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case REQ_ID_HISTORY_START_LOADER:
            return Object.assign(Object.assign({}, state), { reqIdHistoryLoader: true });
        case REQ_ID_HISTORY_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { reqIdHistoryLoader: false });
        default:
            return Object.assign({}, state);
    }
};
export default reqIdHistory;
